import { CPChecklistLogModelType } from '@teinor/erp/types/company/customer/customerProject/cpChecklistLog'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { faCheck, faCopy, faList, faPencil, faPlus, faTimes, faTrashAlt, faTrashCan, faXmark } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../baseComponents/TwinIcon'
import { displayDateWithFormattedHours } from '../../../../utils/globals/date'
import { EmployeeModelType } from '@teinor/erp/types/company/userInner/employee'
import { CustomerProjectRenderImageTooltip } from '../../Subcomponents'
import { ModalBigCentered } from '../../../../baseComponents/Modal'
import TwinTrans from '../../../../baseComponents/TwinTrans'
import { ModalEditComponentProps } from '../../../../baseComponents/ModalsLayouts/types'

interface ModalCustomerProjectChecklistLogProps extends ModalEditComponentProps { }

const ModalCustomerProjectChecklistLog: React.FC<ModalCustomerProjectChecklistLogProps> = ({ allRowData, setOpened }) => {
    const renderThis: JSX.Element[] = []
    if (allRowData?.CPChecklistLogs?.length) {
        for (const log of allRowData?.CPChecklistLogs) {
            renderThis.push(<CPChecklistLog key={log.id} CPCheckChecklistLog={log} />)
        }
    }
    return (
        <ModalBigCentered opened={true} setOpened={() => setOpened(null)} onClickOut={true} className='modal_checklist_log cursor-default'>
            <div className='flex items-center mb-15'>
                <h2>
                    <TwinTrans transKey='logsLists'>Registros listas</TwinTrans>
                </h2>
                <TwinIcon className='ml-auto cursor-pointer' icon={faTimes} onClick={() => setOpened(null)}/>
            </div>
            {allRowData?.CPChecklistLogs && allRowData?.CPChecklistLogs.length > 0 ?
                <div className='grid flex-auto overflow-y-auto'>
                    <div className='flex flex-col flex-auto gap-10'>
                        {renderThis}
                    </div>
                </div>
                :
                <div className='my-auto regular14'>
                    <TwinTrans transKey='noLogsNoChecklist'>No existen registros.</TwinTrans>
                </div>
            }
        </ModalBigCentered>

    )
}

interface CPChecklistLogProps {
    CPCheckChecklistLog: CPChecklistLogModelType
}

const CPChecklistLog: React.FC<CPChecklistLogProps> = ({ CPCheckChecklistLog }) => {
    const { id, logType, EmployeeTrigger, extraData } = CPCheckChecklistLog
    return (
        <RenderLogTypeMessage id={id} value={extraData || ''} logType={logType} employeeTrigger={EmployeeTrigger} date={CPCheckChecklistLog.createdAt} />
    )
}

interface RenderLogTypeMessageProps {
    id: number
    date: string
    value: string
    logType: number
    employeeTrigger?: EmployeeModelType
}

export const RenderLogTypeMessage: React.FC<RenderLogTypeMessageProps> = ({ id, value, logType, employeeTrigger, date }) => {
    const { tVars } = useTwinTranslation()
    const extraDataParsed = JSON.parse(value)
    const options = { ...extraDataParsed }
    const checklistLogTypeMessageDic: TwinDictionary = {
        0: { text: tVars('createCPChecklistMessage', 'ha creado una lista', options), icon: faList },
        1: { text: tVars('copyTChecklistMessage', 'ha copiado la plantilla {{copyListName}} ', options), icon: faCopy },
        2: { text: tVars('createCPChecklistSectionMessage', 'ha creado una sección', options), icon: faPlus },
        3: { text: tVars('updateCPChecklistSectionMessage', 'ha actualizado el nombre de una sección a {{sectionName}}', options), icon: faPencil },
        4: { text: tVars('deleteCPChecklistSectionMessage', 'ha eliminado la sección {{sectionName}}', options), icon: faTrashCan, color: '#BA435D' },
        5: { text: tVars('createCPChecklistTaskMessage', 'ha creado un elemento en la sección {{sectionName}}', options), icon: faPlus },
        6: { text: tVars('updateCPChecklistTaskMessage', 'ha cambiado el nombre de un elemento a {{taskName}}', options), icon: faPencil },
        7: { text: tVars('doneCPChecklistTaskMessage', 'ha marcado el elemento {{taskName}}', options), icon: faCheck },
        8: { text: tVars('undoneCPChecklistTaskMessage', 'ha desmarcado el elemento {{taskName}}', options), icon: faXmark, color: '#BA435D' },
        9: { text: tVars('deleteCPChecklistTaskMessage', 'ha eliminado el elemento {{taskName}}', options), icon: faTrashAlt, color: '#BA435D' },
    }
    const myLogType = checklistLogTypeMessageDic[logType]
    return (
        <div className='flex items-center text-left cp_checklist_log_container'>
            <div className=' flex items-center rounded-full px-8 py-15 border bg-white mr-14 h-34 w-34 z-1' style={{ borderColor: '#D6D6D6' }}>
                <TwinIcon icon={myLogType.icon} className='w-16 h-16 ' style={{ color: myLogType?.color || '#43BAA5' }}></TwinIcon>
            </div>
            <CustomerProjectRenderImageTooltip id={employeeTrigger?.id || 0} img={employeeTrigger?.profile_image || '/user-png.png'} name={employeeTrigger?.fullname_short || ''} tooltipName={String(logType + id)} className='min-w-27' />
            <div className='mx-10 medium14 text-left flex-auto'>{myLogType.text}</div>
            <span className='text-gray-9D ml-auto regular12 cp_checklist_log_date'>{displayDateWithFormattedHours(new Date(date))}</span>
        </div>
    )
}

export default ModalCustomerProjectChecklistLog